import { z } from "zod";

export enum BookabilityDecision {
  BLOCKED = "BLOCKED",
  ALLOWED = "ALLOWED",
  UNDETERMINED = "UNDETERMINED",
}

export enum BookabilityUnmetCriteria {
  FACILITY_CHARGE_RATE_MISSING = "FACILITY_CHARGE_RATE_MISSING",
  FACILITY_PENDING = "FACILITY_PENDING",
  FACILITY_SUSPENDED = "FACILITY_SUSPENDED",
  SHIFT_ALREADY_GRABBED = "SHIFT_ALREADY_GRABBED",
  SHIFT_DELETED = "SHIFT_DELETED",
  SHIFT_IN_PAST = "SHIFT_IN_PAST",
  SHIFT_INSTANT_BOOK_DISABLED = "SHIFT_INSTANT_BOOK_DISABLED",
  SHIFT_INSTANT_BOOK_LEAD_TIME_NOT_SET = "SHIFT_INSTANT_BOOK_LEAD_TIME_NOT_SET",
  SHIFT_INVALID = "SHIFT_INVALID",
  SHIFT_OVERLAPPING = "SHIFT_OVERLAPPING",
  SHIFT_OVERWORKING = "SHIFT_OVERWORKING",
  WORKER_ACCOUNT_IN_REVIEW = "WORKER_ACCOUNT_IN_REVIEW",
  WORKER_CANT_CLAIM_SHIFT = "WORKER_CANT_CLAIM_SHIFT",
  WORKER_DEACTIVATED = "WORKER_DEACTIVATED",
  WORKER_DISABLED_TEST_ACCOUNT = "WORKER_DISABLED_TEST_ACCOUNT",
  WORKER_MISSING_DOCUMENTS = "WORKER_MISSING_DOCUMENTS",
  WORKER_MISSING_LICENSE = "WORKER_MISSING_LICENSE",
  WORKER_MISSING_REQUIREMENTS = "WORKER_MISSING_REQUIREMENTS",
  WORKER_PAYMENTS_DISABLED = "WORKER_PAYMENTS_DISABLED",
  WORKER_PENDING_DOCUMENTS = "WORKER_PENDING_DOCUMENTS",
  WORKER_RESTRICTED = "WORKER_RESTRICTED",
  WORKER_UNSIGNED_AGREEMENT = "WORKER_UNSIGNED_AGREEMENT",
  WORKER_HAS_NOT_PASSED_QUIZ_FOR_WORKPLACE_RULES = "WORKER_HAS_NOT_PASSED_QUIZ_FOR_WORKPLACE_RULES",
  WORKER_HAS_REACHED_DNR_LIMIT = "WORKER_HAS_REACHED_DNR_LIMIT",
}

const bookabilityAttributeSchema = z.discriminatedUnion("decision", [
  z.object({
    decision: z.literal(BookabilityDecision.ALLOWED),
  }),
  z.object({
    decision: z.literal(BookabilityDecision.UNDETERMINED),
  }),
  z.object({
    decision: z.literal(BookabilityDecision.BLOCKED),
    unmetCriteria: z.array(z.nativeEnum(BookabilityUnmetCriteria)).min(1),
  }),
]);

const bookabilityStatusItemSchema = z.object({
  id: z.string(),
  type: z.literal("shift"),
  attributes: z.object({
    bookability: bookabilityAttributeSchema,
  }),
});

export const bookabilityStatusRequestSchema = z.object({
  workerId: z.string(),
  shiftIds: z.string(),
  returnFirstUnmetCriteria: z.boolean().optional(),
});

export const bookabilityStatusResponseSchema = z.object({
  data: z.array(bookabilityStatusItemSchema),
});

export type BookabilityAttributes = z.infer<typeof bookabilityAttributeSchema>;
export type BookabilityStatusItem = z.infer<typeof bookabilityStatusItemSchema>;

export type BookabilityStatusResponse = z.infer<typeof bookabilityStatusResponseSchema>;
export type BookabilityStatusRequest = z.infer<typeof bookabilityStatusRequestSchema>;
